// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__HKX8E","disabled":"Checkbox_disabled__gp7ZW"};